"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaHistoricoEscolar = exports.yupHistoricoEscolar = void 0;
const yup = __importStar(require("yup"));
const estado_1 = require("./estado");
const utils_1 = require("../utils");
// import { ICurso } from './curso';
// import { ISerie } from './serie';
// import { ITurma } from './turma';
exports.yupHistoricoEscolar = yup.object({
    idCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .label('Curso'),
    idSerie: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .label('Série'),
    idTurma: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .label('Turma'),
    idAluno: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Aluno'),
    idHistoricoEscolarGrade: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Historico Escolar Grade'),
    serie: yup.string().default('').required().max(1).label('Série'),
    ano: yup.string().default('').label('Ano'),
    grau: yup.string().default('').label('Nivel'),
    estabelecimento: yup.string().default('').max(85, 'Máximo de 85 caracteres.').default('').label('Estabelecimento'),
    municipio: yup.string().default('').required().label('Cidade').max(40, 'Máximo de 50 caracteres.'),
    estado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .required()
        .default('')
        .label('Estado'),
    habilitacao: yup.string().default('').max(40, 'Máximo de 40 caracteres.').default('').label('Habilitação'),
    cod_rec: yup.number().default(0).label(''),
    cod_rces: yup.number().default(0).label(''),
    resultado: yup.string().default('').max(1).default('').label('Resultado'),
    horas: yup.number().default(0).label('Horas 1'),
    horas2: yup.string().default('').max(3).default('').label('Horas 2'),
    lei: yup.string().default('').max(15, 'Máximo de 15 caracteres.').default('').label('Lei'),
    epocaIni: (0, utils_1.sge2Date)().default(null).nullable().label('Data Inicial'),
    epocaFim: (0, utils_1.sge2Date)().default(null).nullable().label('Data Final'),
    faltas: yup.string().default('').max(3).default('').label('Faltas 1'),
    faltas2: yup.string().default('').max(3).default('').label('Faltas 2'),
    dias: yup.string().default('').max(3).default('').label('Dias 1'),
    dias2: yup.string().default('').max(8).default('').label('Dias 2'),
    frequencia: yup.number().default(0).label('Frequência'),
    min_prom: yup.string().default('').max(3).default('').label('min_prom'),
});
exports.schemaHistoricoEscolar = exports.yupHistoricoEscolar.shape({});
